<template>
  <div>
    <v-row no-gutters>
      <v-col cols="3">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <WarningButton
              x-small
              btnClass="mr-2 rounded"
              icon="mdi-garage-alert"
              iconClass=""
              v-on="on"
              v-bind="attrs"
              @click="pendingDetails"
              v-if="params && params.data && params.data.no_of_step_completed"
            >
            </WarningButton>
          </template>
          <span>Pending</span>
        </v-tooltip>
      </v-col>
      <v-col cols="3">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <SecondaryButton
              x-small
              btnClass="mr-2 rounded"
              icon="mdi-eye"
              iconClass=""
              v-on="on"
              v-bind="attrs"
              @click="viewDetails"
            >
            </SecondaryButton>
          </template>
          <span>Viw Details</span>
        </v-tooltip>
      </v-col>
      <v-col cols="3">
        <v-tooltip bottom>
          <template #activator="{ on, attrs }">
            <PrimaryButton
              x-small
              btnClass="mr-2 rounded"
              icon="mdi-pencil"
              iconClass=""
              v-on="on"
              v-bind="attrs"
              @click="editItem"
            >
            </PrimaryButton>
          </template>
          <span>Edit</span>
        </v-tooltip>
      </v-col>
      <v-col cols="3">
        <v-tooltip top>
          <template #activator="{ on, attrs }">
            <PrimaryButton
              x-small
              btnClass="rounded"
              icon="mdi-autorenew"
              iconClass=""
              v-on="on"
              v-bind="attrs"
              @click="renewSubscription"
            >
            </PrimaryButton>
          </template>
          <span>Renew Subscription</span>
        </v-tooltip>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  methods: {
    editItem() {
      this.$router.push({
        name: "edit-company",
        params: { id: this.params.data.id },
      });
    },
    pendingDetails() {
      this.$router.push({
        name: "add-company",
        query: { companyId: this.params.data.id },
      });
    },
    viewDetails() {
      this.$router.push({
        name: "view-company",
        params: { id: this.params.data.id },
      });
    },
    renewSubscription() {
      this.params.context.parentComponent.openSubscriptionRenewForm(
        this.params.data
      );
    },
  },
};
</script>

<style></style>
